const MARKETPLACE_DOMAIN = 'marketplace.msging.net';
const MARKETPLACE_TEMPLATE_BUFFER = 'marketplace_template_buffer';
export class MarketplaceService {
    static $inject = ['AuthenticationService', 'BlipService', '$translate'];
    constructor(AuthenticationService, BlipService, $translate) {
        'ngInject';
        this.AuthenticationService = AuthenticationService;
        this.BlipService = BlipService;
        this.$translate = $translate;
        this.init();
    }
    init() {
        this.localStorage = window.localStorage;
    }
    async getPlans() {
        return [{ order: 0, value: '00892f5b-0404-40d5-8c1f-a57b7f709877', label: await this.$translate('marketplace.create.plans.standard') },
            { order: 1, value: '43f60cb5-173e-4790-8d90-55aac9991267', label: await this.$translate('marketplace.create.plans.start') },
            { order: 2, value: '2c0c288f-9dee-46b5-a2ab-1529a132def1', label: await this.$translate('marketplace.create.plans.business') },
            { order: 3, value: '7bb2ad52-66bd-4608-9a44-5995c6aa0780', label: await this.$translate('marketplace.create.plans.enterprise') }];
    }
    async connectBlipClient() {
        if (!(await this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
    }
    async getTemplates(tenantId) {
        await this.connectBlipClient();
        const uri = tenantId
            ? `/templates?tenantId=${tenantId}`
            : '/templates';
        const response = await this.BlipService.sendCommand({
            to: `postmaster@${MARKETPLACE_DOMAIN}`,
            method: 'get',
            uri,
        });
        return response.items.map(item => ({ ...item }));
    }
    async saveTemplateHeadstart(headstartObject) {
        const objectToSend = {
            to: `postmaster@${MARKETPLACE_DOMAIN}`,
            method: 'set',
            type: 'application/vnd.iris.marketplace.template+json',
            uri: '/templates',
            resource: { ...headstartObject },
        };
        return await this.BlipService.processCommand(objectToSend);
    }
    async downloadTemplate(templateId, planId, token, tenantId = undefined) {
        const objectToSend = {
            to: `postmaster@${MARKETPLACE_DOMAIN}`,
            method: 'set',
            type: 'application/vnd.lime.document+json',
            resource: { id: templateId, token: token, planId: planId, tenantId: tenantId },
            uri: '/application',
        };
        const response = await this.BlipService.processCommand(objectToSend, 600000);
        this.BlipService.ensureCommandSuccess(response);
        return response.resource;
    }
    async removeTemplate(templateId) {
        const objectToSend = {
            to: `postmaster@${MARKETPLACE_DOMAIN}`,
            method: 'delete',
            uri: `/templates/${templateId}`,
        };
        const response = await this.BlipService.processCommand(objectToSend);
        this.BlipService.ensureCommandSuccess(response);
        return response;
    }
    saveTemplateBuffer(objectToSave) {
        this.localStorage.setItem(MARKETPLACE_TEMPLATE_BUFFER, JSON.stringify(objectToSave));
    }
    getTemplateBuffer() {
        return this.localStorage && this.localStorage.getItem(MARKETPLACE_TEMPLATE_BUFFER) ? JSON.parse(this.localStorage.getItem(MARKETPLACE_TEMPLATE_BUFFER)) : undefined;
    }
}
MarketplaceService.$inject = ['AuthenticationService', 'BlipService', '$translate'];
